import { IssueItem } from '../../../utility/types/components/types';

(function () {
    var $window = $(window);
    var issueItem: IssueItem = {
        vPort: 'screen-sm',
        isMobile: false,

        init: function () {
            issueItem.controls();
            issueItem.truncate();
        },
        truncate: function () {
            let $authors = $('.issue-item__authors .loa');
            if (UX.issueItem.isMobile) {
                $authors.not("[data-truncate='none']").truncate({
                    type: 'list',
                    position: 'betweenFirstAndLast',
                    lines: 1,
                    seeMoreText: '',
                    seeMoreHtml: '',
                    seeLessText: '',
                    seeLessHtml: '<i class="icon-section_arrow_u"></i>',
                    ellipsisChar: '[&hellip;]',
                    addClass: 'author-truncated',
                });
            } else {
                $authors.not("[data-truncate='none']").truncate({
                    lines: 1,
                    type: 'list',
                    position: 'beforeLast',
                    seeMoreText: '',
                    seeMoreHtml: '[&hellip;]',
                    seeLessText: '',
                    seeLessHtml: 'See fewer authors <i class="icon-section_arrow_u"></i>',
                });
            }
            $authors.has('.read-more').addClass('author-truncated');
        },
        controls: function () {
            $window.on('resized orientationchange', function () {
                issueItem.truncate();
            });
            $(document).on(UX.issueItem.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                UX.issueItem.isMobile = true;
                UX.issueItem.truncate();
            });

            $(document).on(UX.issueItem.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                UX.issueItem.isMobile = false;
                setTimeout(function () {
                    $('.issue-item__authors .loa').truncate('destroy');
                }, 500);
            });
        },
    };
    UX.issueItem = issueItem;
})();
